<div class="page-layout">
  <div class="slot-header">
    <h3>{{ title }}</h3>
    <sbb-action-menu [actions]="actions"></sbb-action-menu>
  </div>
  <ng-content></ng-content>
</div>
